import React from 'react'

export default function SignContractInput({ formik }) {
    return (
        <div className="sign-contract col-md-7 mx-auto">
            <h6>Sign contract</h6>
            <div className="form-group">
                <label htmlFor="first_name">First name</label>
                <input
                    type="text"
                    id="first_name"
                    name="first_name"
                    className="form-control"
                    placeholder="Enter first name"
                    value={formik.values.first_name}
                    onChange={formik.handleChange}
                    // disabled={true}
                />
                {formik.touched.first_name && formik.errors.first_name ? (
                    <div className="error">{formik.errors.first_name}</div>
                ) : null}
            </div>
            <div className="form-group">
                <label htmlFor="last_name">Last name</label>
                <input
                    type="text"
                    id="last_name"
                    name="last_name"
                    className="form-control"
                    placeholder="Enter last name"
                    value={formik.values.last_name}
                    onChange={formik.handleChange}
                    // disabled={true}
                />
                {formik.touched.last_name && formik.errors.last_name ? (
                    <div className="error">{formik.errors.last_name}</div>
                ) : null}
            </div>
        </div>
    )
}
